<template>
	<div class='course-content'>
		<div class='course-top overflow'>
			<div class="course-title">参赛{{region_theme_text}}</div>
			<button class="back-btn" type="button" @click="edit">
				<span><img src="../assets/img/no-edit.png"></span>
				<span>返回</span>
			</button>
		</div>
		<div class="search-top overflow">
				<div class="checkbox-div">
					<span>视频：</span>
						<el-checkbox-group
							v-model="videoStatusArr"
							@change="onVideoStatusChange"
							style="margin-right: 10px;"
						>
							<el-checkbox-button :label="1">有</el-checkbox-button>
							<el-checkbox-button :label="0">无</el-checkbox-button>
						</el-checkbox-group>
						<!-- <span style="margin-right: 8px;">音频：</span>
						<el-checkbox-group
							v-model="audioStatusArr"
							@change="onAudioStatusChange"
							style="margin-right: 10px;"
						>
							<el-checkbox-button :label="1">有</el-checkbox-button>
							<el-checkbox-button :label="0">无</el-checkbox-button>
						</el-checkbox-group> -->
						<span>附件：</span>
						<el-checkbox-group
							v-model="fileStatusArr"
							@change="onFileStatusChange"
						>
							<el-checkbox-button :label="1">有</el-checkbox-button>
							<el-checkbox-button :label="0">无</el-checkbox-button>
						</el-checkbox-group>
				</div>
				<el-input :placeholder="'输入编码/' + util.getKeyFrontValue('name') + '/所属单位进行搜索'"  class="search-input" v-model="search"></el-input>
				<button class="search-btn" type="button" @click="searchList"><i class="el-icon-search"></i>搜索</button>
				<button class="reset-btn" type="button" @click="reset">重置</button>
			</div>
		<div>
			<div class="table-content">
				<el-table :data="tabList" v-loading="loading" border stripe :header-cell-style="{background: '#EEF7FE',color:'black'}">
					<el-table-column prop="id" label="编码" align="center" width="123"></el-table-column>
					<el-table-column :label="util.getKeyFrontValue('cover')" width="120" align="center">
						<template slot-scope="scope">
							<el-popover placement="right" title="" trigger="hover" width="250" style="cursor: pointer;">
								<el-image slot="reference" :src="alOssUrl+scope.row.cover+util.imgSize.imgQ40"
									style="height: 75px;width:60px"></el-image>
								<el-image :src="alOssUrl+scope.row.cover+util.imgSize.imgQ40"></el-image>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="name" :label="util.getKeyFrontValue('name')" align="center" min-width="220">
						<template slot-scope="scope">
							<div>
								<div class="row-name">{{ scope.row.name }}</div>
								<span v-if="scope.row.o_course_category && scope.row.o_course_category.kind == 'labor'" class="labor-label comment-margin-right-5">劳动教育</span>
								<span v-if="scope.row.o_course_category && scope.row.o_course_category.kind == 'comprehensive'" class="comprehensive-label comment-margin-right-5">综合实践</span>
								<span class="stage-label">
									{{ util.setStage(scope.row.m_competition_course_to_apply) }}
								</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="o_competition_course_author.affiliation" label="所属单位" align="center" width="180">
						<template slot-scope="scope">
							<div>
								{{scope.row.o_competition_course_author ? scope.row.o_competition_course_author.affiliation : ''}}
							</div>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="o_competition_course_comment.content" label="写评语" min-width="200">
						<template slot-scope="scope">
							<div v-if="scope.row.o_competition_course_comment && scope.row.o_competition_course_comment.content">
								{{ scope.row.o_competition_course_comment.content }}
							</div>
							<div v-else>
								<el-button type="text" style="color: #44D89E;" v-if="scope.row.o_competition_course_comment == null"
									@click="review_store(scope.row)">写评语</el-button>
								<el-button type="text" style="color: #44D89E;" v-else
									@click="review_update(scope.row)">写评语</el-button>
							</div>
						</template>
					</el-table-column> -->
					<el-table-column prop="" label="评分人数" align="center" width="80">
						<template slot-scope="scope">
							{{scope.row.o_competition_course_comment_statistic == null ? '暂无' : scope.row.o_competition_course_comment_statistic.count}}
						</template>
					</el-table-column>
					<el-table-column prop="o_competition_course_rate" label="得分" align="center" width="100">
						<template slot="header" slot-scope="scope">
							得分
							<el-popover placement="top-start" width="200" trigger="hover"
								content="取所有评分的平均分">
								<i slot="reference" class="el-icon-info icon-style"></i>
							</el-popover>
						</template>
						<template slot-scope="scope">
							{{scope.row.o_competition_course_rate == null ? '暂无' : scope.row.o_competition_course_rate.rate / 10}}
						</template>
					</el-table-column>
					<el-table-column label="操作" min-width="200" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button type="text" style="color: #44D89E;" @click='detail_click(scope.row)'>详情</el-button>
							<el-button type="text" style="color: #44D89E;"
							v-if="scope.row.o_competition_course_comment && scope.row.o_competition_course_comment.content"
							@click='comment_click(scope.row)'>专家评语</el-button>
							<el-button v-if="scope.row.o_competition_course_comment == null" type="text" @click='review_store(scope.row)' style="color: #FF4E00;">评分</el-button>
							<el-button v-else type="text" style="color: #1FB4F9;" @click='review_update(scope.row)'>修改评分</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="block">
				<el-pagination v-if='total > 0' background @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total" :current-page="currentPage">
				</el-pagination>
			</div>
		</div>
		<courseDetail ref="courseDetail" role="review"></courseDetail>
		<!-- 评分 -->
		<EvaluationScore ref="EvaluationScore" @refresh="getList"></EvaluationScore>
		<!-- 专家评语 -->
		<el-dialog title="专家评语" :visible.sync="commentVisible" center width="500px">
			<div v-html="commentContent"></div>
		</el-dialog>
	</div>
</template>

<script>
	import courseDetail from '../components/courseDetail.vue'
	import EvaluationScore from '../components/evaluationScore.vue'
	export default {
		name: 'index',
		components: {
			courseDetail,
			EvaluationScore
		},
		data() {
			return {
				region_theme_text: JSON.parse(sessionStorage.getItem('region_theme_text')) ? JSON.parse(sessionStorage.getItem('region_theme_text')) : '课程',
				tabList: [],
				pageSize: 5,
				total: 0,
				currentPage: 1,
				search: '',
				loading: false,
				videoStatusArr: [],
				audioStatusArr: [],
				fileStatusArr: [],
				commentVisible: false,
				commentContent: '',
			}
		},
		methods: {
			// 详情
			detail_click(row) {
				this.$refs.courseDetail.show(row)
			},
			// 专家评语
			comment_click(row) {
				this.commentVisible = true
				this.commentContent = row.o_competition_course_comment.content
			},
			// 修改评分
			review_update(row) {
				this.$refs.EvaluationScore.update(row)
			},
			//评分
			review_store(row) {
				this.$refs.EvaluationScore.show(row)
			},
			//返回
			edit() {
				this.$router.push({
					name: 'index'
				})
			},
			
			//分页
			handleSizeChange(val) {
				this.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList();
			},
			// 搜索
			searchList() {
				this.currentPage = 1
				this.getList()
			},
			// 重置
			reset() {
				this.search = ''
				this.videoStatusArr = []
				this.audioStatusArr = []
				this.fileStatusArr = []
				this.currentPage = 1
				this.getList()
			},
			getList() {
				this.loading = true
				this.HttpUtil.Get(this.api.expert.competitionCourseList, {
					page: this.currentPage,
					limit: this.pageSize,
					competition_course_poster_id: sessionStorage.getItem('competition_course_poster_id'),
					sf3: this.search,
					sq1: this.videoStatusArr.includes(1) ? 1 : null,
					sq2: this.videoStatusArr.includes(0) ? 1 : null,
					sq3: this.fileStatusArr.includes(1) ? 1 : null,
					sq4: this.fileStatusArr.includes(0) ? 1 : null,
					sq5: this.audioStatusArr.includes(1) ? 1 : null,
					sq6: this.audioStatusArr.includes(0) ? 1 : null,
					target: 'comment',
				}).then((res) => {
					this.tabList = res.list
					this.loading = false
					this.total = res.total
				})
			},
			onVideoStatusChange(val) {
				if (val.length > 0) {
					this.videoStatusArr = [val[val.length - 1]]
				} else {
					this.videoStatusArr = []
				}
			},
			onAudioStatusChange(val) {
				if (val.length > 0) {
					this.audioStatusArr = [val[val.length - 1]]
				} else {
					this.audioStatusArr = []
				}
			},
			onFileStatusChange(val) {
				if (val.length > 0) {
					this.fileStatusArr = [val[val.length - 1]]
				} else {
					this.fileStatusArr = []
				}
			},
		},
		mounted() {
			this.getList()
		},
		destroyed() {
			sessionStorage.removeItem("review")
		},
		watch: {

		}
	}
</script>

<style scoped="scoped">
	.course-content {
		width: 68%;
		min-width: 1100px;
		height: 73vh;
		margin: 0 auto;
		background-color: white;
		padding: 20px 10px 20px 25px;
		box-sizing: border-box;
		overflow-y: scroll;
		box-shadow: 0 0 100px rgba(31, 180, 249, 0.26);
	}

	.course-top {
		/* height: 40px; */
		margin-bottom: 10px;
		display: flex;
		justify-content: space-between;
		/* align-items: center; */
	}
	.search-top .el-checkbox-group {
		display: inline;
		margin-right: 20px;
		font-size: 14px;
	}
	.search-top {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 10px;

	}

	.course-title {
		font-size: 20px;
		font-weight: bold;
		color: #333333;
		letter-spacing: 1px;
		margin-bottom: 15px;
		flex-shrink: 0;
	}

	.el-table td,
	.el-table th {
		padding: 8px 0 !important;
	}

	.table-content {
		/* min-height: 49vh;
		max-height: 48vh; */
		min-height: 49vh;
		overflow-y: scroll;
	}

	.table-content /deep/ .el-table td {
		padding: 6px 0 !important
	}

	.table-content /deep/ .el-table th {
		padding: 6px 0 !important
	}

	/* 分页 */
	.block {
		text-align: center;
		margin-top: 20px;
	}
	/*表格hover*/
	/deep/.el-tag {
		border-radius: 0;
		background: none;
		border: none;
		color: black;
		font-size: 14px;
		/*line-height: 60px;*/
	}
	
	.search-input {
		width: 300px;
		height: 40px;
		margin-right: 20px;
	}
	.search-input /deep/ .el-input__inner {
		height: 40px;
		line-height: 38px;
	}
	.search-btn {
		width: 80px;
		height: 40px;
		background: #FF3B3D;
		box-shadow: 0px 3px 6px rgba(255, 59, 61, 0.16);
		opacity: 1;
		border-radius: 5px;
		font-size: 16px;
		color: #ffffff;
		border: none;
		margin-right: 20px;
		cursor: pointer;
	}
	.search-btn:hover {
		background: #C6191F;
	}
	.search-btn i {
		margin-right: 5px;
	}
	.reset-btn {
		box-sizing: border-box;
		width: 80px;
		height: 40px;
		/* background: rgba(255, 255, 255, 0.39); */
		background: #E8E8E8;
		/* box-shadow: 0px 3px 6px #FF3B3D; */
		opacity: 1;
		border-radius: 5px;
		font-size: 16px;
		/* color: #FF3B3D; */
		color: #333333;
		border: none;
		/* border: 1px solid #FF3B3D; */
		cursor: pointer;
		margin-right: 40px;
	}
	.reset-btn:hover {
		background: #D1D1D1;
	}
	.back-btn {
		box-sizing: border-box;
		/* width: 80px; */
		padding: 0 20px;
		height: 40px;
		line-height: 40px;
		background: #E8E8E8;
		/* box-shadow: 0px 3px 5px 0px rgba(255,59,61,0.1500), 0px -5px 5px 0px rgba(255,59,61,0.0500); */
		opacity: 1;
		border-radius: 5px;
		font-size: 16px;
		color: #333333;
		border: none;
		cursor: pointer;
	}
	.back-btn:hover {
		background: #D1D1D1;
	}
	.back-btn img {
		margin-right: 10px;
		width: 13px;
		height: 13px;
		margin-top: 2px;
	}
	.icon-style {
		color: #ffffff;
		background-color: #999999 !important;
		border-radius: 50%;
		margin-left: 1px;
	}
	
	.row-name {
		font-size: 14px;
		line-height: 14px;
		margin-bottom: 10px;
	}
	.labor-label {
		display: inline-block;
		width: 50px;
		height: 14px;
		padding: 2px 0;
		background: #EBFFF7;
		text-align: center;
		border-radius: 1px;
		color: #44D89E;
		font-size: 10px;
		line-height: 14px;
	}
	.comprehensive-label {
		display: inline-block;
		width: 50px;
		height: 14px;
		padding: 2px 0;
		background: #FFF1EB;
		text-align: center;
		border-radius: 1px;
		color: #FB824E;
		font-size: 10px;
		line-height: 14px;
	}
	.stage-label {
		display: inline-block;
		min-width: 50px;
		height: 14px;
		padding: 2px 3px;
		background: #EFF6FF;
		text-align: center;
		border-radius: 1px;
		color: #1950A2;
		font-size: 10px;
		line-height: 14px;
	}
</style>
